
import './App.scss';
import { Header } from './components/commons/header/header';
import { Footer } from './components/commons/footer/footer';
import { Outlet } from 'react-router-dom';
import { LanguageProvider } from './providers/LanguageProvider';
import { Toaster } from 'react-hot-toast';


function App() {


  return (
    <>
      <LanguageProvider> 
        <Toaster position="top-right" reverseOrder={false}
        toastOptions={{
          success: {
            style: {
              background: 'green',
              color:"white"
            },
          },
          error: {
            style: {
              background: '#C60000',
              color:"white"
            },
          },
        }} />
        <Header/>
        <Outlet/>
        <Footer/>
      </LanguageProvider>
    </>
  )
}

export default App
